import { render } from "./ModalResponsavelConta.vue?vue&type=template&id=5067adcc&scoped=true"
import script from "./ModalResponsavelConta.vue?vue&type=script&lang=js"
export * from "./ModalResponsavelConta.vue?vue&type=script&lang=js"

import "./ModalResponsavelConta.vue?vue&type=style&index=0&id=5067adcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5067adcc"]])

export default __exports__